// eslint-disable-next-line no-extend-native
String.prototype.htmlEscape = function() {
    return Handlebars.Utils.escapeExpression(this)
}
